import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function UrgencyBlock() {
  // Start at 23:59:48
  const initialSeconds = 23 * 3600 + 59 * 60 + 48;
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) return 23 * 3600 + 59 * 60 + 59; // Reset
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (totalSeconds: number) => {
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor(totalSeconds % 3600 / 60);
    const s = totalSeconds % 60;
    return {
      h: h.toString().padStart(2, '0'),
      m: m.toString().padStart(2, '0'),
      s: s.toString().padStart(2, '0')
    };
  };
  const {
    h,
    m,
    s
  } = formatTime(timeLeft);
  return <div className="w-full max-w-3xl mx-auto bg-red-50 border-2 border-danger rounded-2xl p-6 md:p-8 text-center shadow-lg my-12" data-id="element-306">
      <div className="flex items-center justify-center gap-2 text-danger font-bold uppercase tracking-wider mb-4" data-id="element-307">
        <Clock size={20} data-id="element-308" />
        <span data-id="element-309">EL PRECIO DE LANZAMIENTO TERMINA EN:</span>
      </div>

      <div className="flex justify-center items-center gap-2 md:gap-4 mb-4" data-id="element-310">
        <div className="bg-white border border-red-200 rounded-lg p-3 md:p-4 w-20 md:w-24 shadow-sm" data-id="element-311">
          <div className="font-display text-4xl md:text-5xl text-navy-900" data-id="element-312">
            {h}
          </div>
          <div className="text-xs text-navy-500 font-bold uppercase mt-1" data-id="element-313">
            Horas
          </div>
        </div>
        <div className="text-2xl font-bold text-danger" data-id="element-314">:</div>
        <div className="bg-white border border-red-200 rounded-lg p-3 md:p-4 w-20 md:w-24 shadow-sm" data-id="element-315">
          <div className="font-display text-4xl md:text-5xl text-navy-900" data-id="element-316">
            {m}
          </div>
          <div className="text-xs text-navy-500 font-bold uppercase mt-1" data-id="element-317">
            Min
          </div>
        </div>
        <div className="text-2xl font-bold text-danger" data-id="element-318">:</div>
        <div className="bg-white border border-red-200 rounded-lg p-3 md:p-4 w-20 md:w-24 shadow-sm" data-id="element-319">
          <div className="font-display text-4xl md:text-5xl text-navy-900" data-id="element-320">
            {s}
          </div>
          <div className="text-xs text-navy-500 font-bold uppercase mt-1" data-id="element-321">
            Seg
          </div>
        </div>
      </div>

      <p className="text-navy-800 font-medium mb-6" data-id="element-322">
        Después sube $8.000 ARS y no vuelve a bajar.
      </p>

      <div className="max-w-md mx-auto" data-id="element-323">
        <div className="flex justify-between text-sm font-bold text-navy-700 mb-2" data-id="element-324">
          <span data-id="element-325">Cupos al precio de lanzamiento</span>
          <span data-id="element-326">68% tomados</span>
        </div>
        <div className="h-4 w-full bg-red-100 rounded-full overflow-hidden" data-id="element-327">
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: '68%'
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="h-full bg-danger rounded-full relative" data-id="element-328">
            {/* Animated stripe effect */}
            <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.15)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.15)_50%,rgba(255,255,255,0.15)_75%,transparent_75%,transparent)] bg-[length:1rem_1rem] animate-[progress_1s_linear_infinite]" data-id="element-329"></div>
          </motion.div>
        </div>
      </div>
      <style data-id="element-330">{`
        @keyframes progress {
          0% { background-position: 1rem 0; }
          100% { background-position: 0 0; }
        }
      `}</style>
    </div>;
}